import { TFunction } from 'i18next';
import { IBKJComboBoxProps } from '@bookjane2/bookjane-design-library/lib/components/BKJComboBox/BKJComboBox.types';
import { NotificationPreferenceControlEnum } from 'types/graphql';

export const getNotificationPreferenceControlOptions = (
  t: TFunction,
): IBKJComboBoxProps['options'] =>
  [
    {
      value: NotificationPreferenceControlEnum.SCHEDULER_ONLY,
      label: t('settings:NOTIFICATION_PREFERENCE_SCHEDULER_ONLY'),
    },
    {
      value: NotificationPreferenceControlEnum.TEAM_MEMBER_AND_SCHEDULER,
      label: t('settings:NOTIFICATION_PREFERENCE_TEAM_MEMBER_AND_SCHEDULER'),
    },
  ].map((item) => ({ ...item, key: item.value, id: item.value }));
